import { Link, useLocation, useNavigate } from "react-router-dom";
import { useI18n } from "../context/I18nContext";
import { scrollToId } from "../lib/scroll";

export default function Footer() {
  const { t, lang, setLang, languages } = useI18n();
  const location = useLocation();
  const navigate = useNavigate();

  const go = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 420);
    } else scrollToId(id);
  };

  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-charcoal pb-10 pt-20 text-cream">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="flex flex-col gap-12 border-b border-white/10 pb-14 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="font-serif text-5xl leading-[0.95] md:text-7xl">
              Wild<br />
              Spoon<span className="text-terra">.</span>
            </p>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-cream/60">{t.footer.tagline}</p>
            <p className="mt-4 font-corm text-lg italic text-terra">{t.footer.brandPhrase}</p>
          </div>
          <div className="grid grid-cols-2 gap-10 text-sm sm:grid-cols-3">
            <div className="space-y-3">
              <p className="text-[10px] uppercase tracking-[0.3em] text-cream/40">{t.footer.navTitle}</p>
              <button
                data-testid="footer-link-experiencias"
                onClick={() => go("experiencias")}
                className="block text-cream/75 transition-colors hover:text-cream"
              >
                {t.footer.nav.experiencias}
              </button>
              <Link
                data-testid="footer-link-reservas"
                to="/reservas"
                className="block text-cream/75 transition-colors hover:text-cream"
              >
                {t.footer.nav.reservas}
              </Link>
              <button
                data-testid="footer-link-contacto"
                onClick={() => go("contacto")}
                className="block text-cream/75 transition-colors hover:text-cream"
              >
                {t.footer.nav.contacto}
              </button>
            </div>
            <div className="space-y-3">
              <p className="text-[10px] uppercase tracking-[0.3em] text-cream/40">{t.footer.legalTitle}</p>
              <Link data-testid="footer-link-aviso" to="/aviso-legal" className="block text-cream/75 transition-colors hover:text-cream">
                {t.footer.legal.aviso}
              </Link>
              <Link data-testid="footer-link-privacidad" to="/privacidad" className="block text-cream/75 transition-colors hover:text-cream">
                {t.footer.legal.privacidad}
              </Link>
              <Link data-testid="footer-link-cookies" to="/cookies" className="block text-cream/75 transition-colors hover:text-cream">
                {t.footer.legal.cookies}
              </Link>
              <button
                data-testid="footer-cookie-settings"
                onClick={() => window.dispatchEvent(new Event("cs-open-cookie-settings"))}
                className="block text-left text-cream/75 underline underline-offset-4 transition-colors hover:text-cream"
              >
                {t.cookiesUI.footerLink}
              </button>
            </div>
            <div className="space-y-3">
              <p className="text-[10px] uppercase tracking-[0.3em] text-cream/40">{t.footer.lang}</p>
              <div className="flex gap-3">
                {languages.map(([code, label]) => (
                  <button
                    key={code}
                    data-testid={`footer-language-${code}`}
                    onClick={() => setLang(code)}
                    className={`text-xs tracking-widest transition-colors ${
                      lang === code ? "text-terra" : "text-cream/50 hover:text-cream"
                    }`}
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-3 pt-8 text-xs text-cream/40 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright">© {year} Wild Spoon — Edu Vincent · Granada</p>
          <p>{t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}
